import styled from 'styled-components';

export const StyledFileName = styled.div`
  max-width: 250px;
  word-break: break-all;
`;
